import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

/**
 * Formats a datetime string in CET timezone.
 *
 * @param dateISO - The datetime string in ISO format (e.g., "2025-07-30T21:37:43").
 * @returns Formatted datetime string in CET timezone.
 */
export function formatISODateInCETTimezone(
  dateISO: string,
  formatStr: string
): string {
  return format(new TZDate(`${dateISO}Z`, 'CET'), formatStr);
}
